import TickIcon from "../../media/TickIcon"
import "./Checkbox.css"
import { CheckboxProps } from "./Checkbox.types"

/**
 * Checkbox is responsible for rendering a checkable checkbox component along with a label.
 * 
 * @param {string}   label label of the checkbox
 * @param {boolean}  isChecked controls if the checkbox is checked
 * @param {Function} onClick callback function called when the check box is clicked 
 */
const Checkbox = (props: CheckboxProps) => {

  const { label, checkbox, isLoading, enabled } = props

  const onCheckboxClick = () => {
    if (enabled === false) { return }
    checkbox.onChange()
  }

  return (
    !isLoading ? (
      <div className={`checkbox-container`}>
        <div
          className={`checkbox ${checkbox.value ? "checkbox-selected" : ""} ${enabled === false ? "checkbox-disabled" : ""}`}
          onClick={onCheckboxClick} 
          data-testid="checkbox"
        >
          {checkbox.value && (
            <TickIcon />
          )}
        </div>
        <p>{label}</p>
      </div>
    ) : (
      <div className="checkbox-container">
        <div className="loading-checkbox-label"></div>
        <div className="loading-checkbox"></div>
      </div>
    )
  )
}

Checkbox.defaultType = {
  isLoading: false
}

export default Checkbox